/*
 * @Author: Michael 
 * @Date: 2018-01-05 10:53:19 
 * @Last Modified by: Michael
 * @Last Modified time: 2020-03-23 11:06:42
 */
export default {
  routes: [{
    path: '/home_work',
    name: 'home_work',
    component: () => import('@/module/homework/HomeWorkManagePage.vue'),
    meta: {
      title: '学习计划',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/home_work/detail',
    name: 'home_work_detail',
    component: () => import('@/module/homework/HomeWorkDetailPage.vue'),
    meta: {
      title: '单次学习计划详情',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/repeat_home_work/detail',
    name: 'repeat_home_work_detail',
    component: () => import('@/module/homework/RepeatHomeWorkDetailPage.vue'),
    meta: {
      title: '连续学习计划详情',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/home_work/comment',
    name: 'home_work_comment',
    component: () => import('@/module/homework/HomeWorkCommentPage.vue'),
    meta: {
      title: '已提交学习计划',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/home_work/comment/edit',
    name: 'home_work_comment_edit',
    component: () => import('@/module/homework/HomeWorkCommentEditPage.vue'),
    meta: {
      title: '评论学习计划',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/home_work/comment/edit',
    name: 'home_work_comment_replay_edit',
    component: () => import('@/module/homework/HomeWorkCommentEditPage.vue'),
    meta: {
      title: '回复评论',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/home_work/correct',
    name: 'home_work_correct',
    component: () => import('@/module/homework/HomeWorkCorrectPage.vue'),
    meta: {
      title: '学习计划批改结果',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/exam_home_work/detail',
    name: 'exam_home_work_detail',
    component: () => import('@/module/homework/ExamHomeWorkDetailPage.vue'),
    meta: {
      title: '测评学习计划详情',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/home_work/exam_report',
    name: 'home_work_exam_report',
    component: () => import('@/module/homework/ExamHomeWorkReport.vue'),
    meta: {
      title: '测评报告',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/home_work/submit_detail',
    name: 'home_work_submit_detail',
    component: () => import('@/module/homework/HomeWorkSubmitDetail.vue'),
    meta: {
      title: '学习计划提交详情',
      keepAlive: false,
      logined: true
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/Homework.js